document.addEventListener("DOMContentLoaded", () => {
    const bannerButton = document.querySelector(".banner-button-wrapper a");
    const section = document.getElementById("section--build-subscription");
  
    bannerButton.addEventListener("click", () => {
      section.scrollIntoView({
        behavior: "smooth",
      });
    });
  });
  
